/* eslint-disable no-unused-vars */
import { BlockExamItem, BlockExamItems } from '../../components/Builder/BlockTypes/BlockExam/BlockExam.types';
import { BlockFormItem, BlockFormItems, RootCallback, ItemCallback, SubItemCallback } from '../../components/Builder/BlockTypes/BlockForm/BlockForm.types';

const useFormStructure = <T extends BlockFormItems | BlockExamItems, U extends BlockFormItem | BlockExamItem>(items: T | undefined, cbRoot: RootCallback, cbItem: ItemCallback<U>, cbSubItem?: SubItemCallback) => {

	/**
     * Creates the root container of the structure
     * 
     * @returns {JSX.Element | undefined}
     */
	const createRoot = (): JSX.Element | undefined => {
		if(items) {
			const root = items.root;
			const rootItems = root.children;
			const formItems = createItems(rootItems, 'root');
    
			return cbRoot(formItems);
		}
		
	};

	/**
     * Creates the individual items of the structure
     * 
     * @param {string[]} itemKeys 
     * @param {string} parent 
     * @returns {JSX.Element[] | undefined}
     */
	const createItems = (itemKeys: string[], parentKey: string): JSX.Element[] | undefined => {
		if(items) {
			return itemKeys.map((itemKey, index) => {
				const item = items[itemKey];
				const parentItem = items[parentKey];
                
				const children = createSubItem(item, item.children, parentKey);
    
				return cbItem(item, index, parentItem, children);	
			});
		}

		return undefined;
	};

	/**
     * Creates a subitem, could be used to create nested items
     * 
     * @param {BlockFormItem | BlockExamItem} item 
     * @param {string} children 
     * @param {string} parent 
     * @returns {JSX.Element[] | JSX.Element | undefined} 
     */
	const createSubItem = (item: BlockFormItem | BlockExamItem, children: string[], _parent: string): JSX.Element | JSX.Element[] | undefined => {

		if(!children.length) return undefined;

		const itemChildren = createItems(children, item.key);

		if(cbSubItem) {
			return cbSubItem(itemChildren, item.key);
		} 

		return itemChildren;
	};

	/**
     * Alias function for "createRoot".
     * Exists only to give a clerar API usage
     * 
     * @returns {JSX.Element | undefined}
     */
	const buildForm = (): JSX.Element | undefined => {
		return createRoot();
	};

	return {
		buildForm,
		createItems
	};
};

export default useFormStructure;